<div class="background-bar">
  <div class="button-flex">
    <div>
      <p-button icon="pi pi-search" label="buscar" severity="secondary" (click)="isSearchVisible = true" />
    </div>

    @if (options()?.showCreateButton) {
    <span class="admin">
      <p-button icon="pi pi-plus" label="Crear Nueva" severity="secondary" (click)="createNew()" />
    </span>
    }
  </div>

  @if(options()?.showViewButton){
  <p-button icon="pi pi-objects-column" variant="text" (click)="doItemAction({ action: 'changeView', item: null })" severity="secondary"></p-button>
  } @if(options()?.showActions){ @for(item of items(); track $index) {
  <p-button [icon]="item.icon" variant="text" (click)="doItemAction({ action: item.title, item: item })" severity="secondary"></p-button>
  }

  <div class="button-flex">
    <p-button icon="pi pi-filter" label="Filtrar" severity="secondary" (click)="isFilterVisible = true" />
  </div>
  }
</div>

@if (placeholder) {
<span class="search-flex" (click)="search(null)"> <i class="pi pi-times"></i>{{ placeholder }} </span>
}

<p-dialog [(visible)]="isSearchVisible" [dismissableMask]="true" [modal]="true" [showHeader]="false" (onHide)="isSearchVisible = false">
  <p>Haz una búsqueda (Enter)</p>
  <div>
    <span>
      <input (keydown.enter)="search(placeholder)" type="text" pInputText [(ngModel)]="placeholder" />
    </span>
  </div>
</p-dialog>

<p-dialog [(visible)]="isFilterVisible" [modal]="true" [style]="{ width: '70vw', height: '70vh' }" [header]="'Filtros'">
  <div class="flex flex-column gap-4">
    <!-- Sort Options -->
    <div class="field">
      <label class="font-semibold block mb-2">Ordenar por</label>
      <p-select [options]="sortOptions" [(ngModel)]="selectedSort" optionLabel="label" [style]="{ width: '100%' }" placeholder="Seleccionar orden"> </p-select>
    </div>

    <p-multiselect
      [options]="availibleFilters"
      [(ngModel)]="selectedFilters"
      optionLabel="name"
      placeholder="Filtros Rápidos"
      [maxSelectedLabels]="3"
      styleClass="w-full md:w-80" />

    <!-- Date Filter -->
    <div class="field">
      <label class="font-semibold block mb-2">Rango de fechas</label>
      <p-calendar
        [(ngModel)]="dateRange"
        selectionMode="range"
        [showButtonBar]="true"
        [style]="{ width: '100%' }"
        placeholder="Seleccionar fechas"
        dateFormat="dd/mm/yy">
      </p-calendar>
    </div>

    @if (customFilters?.length > 0) {
    <h4>Filtros Personalizados (No terminado...) </h4>
    <h6>Encontrar la forma de que cada custom filter se renderize como un nuevo form.</h6>
    @for (filter of customFilters; track filter.name) {
    <div class="field">
      <label class="font-semibold block mb-2">{{ filter.name }}</label>
    </div>
    } }

    <!-- Recent/All Toggle -->
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Limpiar" icon="pi pi-trash" (click)="clearFilters()" styleClass="p-button-text"> </p-button>
      <p-button label="Aplicar" icon="pi pi-check" (click)="applyFilters()" severity="primary"> </p-button>
    </div>
  </ng-template>
</p-dialog>
